export default __webpack_public_path__ + "static/media/diamond.6982655d.png";